import BaseAPI from '../base'

function getList() {
    return BaseAPI.get(`changelog/list`);
}

export default {
    getList
}